module.exports = __webpack_public_path__ + "static/media/hexgon.a87e7aed.jpg";